import React, { FC } from 'react';
import styles from './_styles.module.scss';

const Expiration: FC<{ date: string | null }> = ({ date }) => {
  return <span className={styles.date}>{date ? date : '-'}</span>;
};

export default Expiration;
